import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { MuiMarkdown } from "@src/appV2/lib";
import { type ReactElement, type ReactNode } from "react";

interface DescriptionProps {
  title: string;
  description: string;
  children?: ReactNode;
}

export function DocumentDetailsSection(props: DescriptionProps): ReactElement {
  const { title, description, children } = props;

  return (
    <Stack spacing={3}>
      <Text semibold variant="h5" sx={{ color: (theme) => theme.palette.text.secondary }}>
        {title}
      </Text>

      <Box
        sx={(theme) => ({
          color: theme.palette.text.secondary,
        })}
      >
        {/* TODO: Add markdown component to cbh-core with custom line height */}
        <MuiMarkdown variant="body1" lineHeight="1.3">
          {description}
        </MuiMarkdown>
      </Box>

      {/* TODO: Add implement `Read more` button / link? */}
      {children}
    </Stack>
  );
}
